module.exports = __webpack_public_path__ + "static/media/8OLA10.fcb27dd7.jpg";